module.exports = __webpack_public_path__ + "static/media/blog-13.8750024c.svg";